'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _querystring = require('querystring');

var _querystring2 = _interopRequireDefault(_querystring);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var parseSearch = function parseSearch(search) {
    search = search.replace(/^\?/, '');
    return _querystring2.default.parse(search);
};

exports.default = {
    getState: function getState(newProps) {
        var query = parseSearch(newProps.location.search);
        var pgsz = parseInt(query.pgsz, 10);
        var lastResultsPage = Math.floor(newProps.total / pgsz);
        var lastResultsRemainder = newProps.total % pgsz;
        if (lastResultsRemainder === 0 && lastResultsPage > 0) {
            lastResultsPage--;
        }
        var lastFrom = lastResultsPage * pgsz;
        return {
            from: lastFrom,
            pgsz: pgsz,
            sortKey: query.sortKey,
            sortDir: query.sortDir,
            filter: query.filter
        };
    }
};
//# sourceMappingURL=newStatePageReset.js.map